export default "__VITE_ASSET__604a3bde__"